import React, { useState, useEffect } from 'react';
import DataTableReact from '../../components/common/datatable/DataTableReact';
import { RightArrow, Dots } from '../../assets/svg.js';
import addline from '../../assets/icons/add-line.svg';
import NewRequest from '../../components/common/newRequest/NewRequest.jsx';
import RequestDetail from '../../components/common/requestDetail/RequestDetail.jsx';
import apiService from '../../services/apiService.js';
import time from '../../assets/icons/time-fill.svg';
import Accepted from '../../assets/icons/check-double-fill.svg';
import Closed from '../../assets/icons/select-box-circle-fill (3).svg';
import Rejected from '../../assets/icons/close-circle-fill.svg';
import Approved from '../../assets/icons/megaphone.svg';
import Partially from '../../assets/icons/circle-half.svg';
import SignatureModal from 'components/common/signatureModal';
import debounce from 'lodash.debounce';
import CustomDropDown from '../../components/common/dropdown/Dropdown.jsx';
import useMedicalSpecialties from 'components/common/medSpecialty/MedicalSpecialty.jsx';

const actionStatuses = [
  { value: 'Approved', label: 'Approved' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Rejected', label: 'Rejected' },
  { value: 'Partially_Approved', label: 'Partially Approved' },
  { value: 'Closed', label: 'Closed' },
  { value: 'Rejected', label: 'Rejected' },
];

const medicalSpecialties = [
  { value: 'Cardiology', label: 'Cardiology' },
  { value: 'Dermatology', label: 'Dermatology' },
  { value: 'Neurology', label: 'Neurology' },
  { value: 'Pediatrics', label: 'Pediatrics' },
  { value: 'Psychiatry', label: 'Psychiatry' },
  { value: 'Obstetrics-and-gynecology', label: 'Obstetrics and Gynecology' },
  { value: 'Orthopedics', label: 'Orthopedics' },
  { value: 'Radiology', label: 'Radiology' },
  { value: 'Gastroenterology', label: 'Gastroenterology' },
  { value: 'Pulmonology', label: 'Pulmonology' },
  { value: 'Hematology', label: 'Hematology' },
  { value: 'Urology', label: 'Urology' },
  { value: 'Ophthalmology', label: 'Ophthalmology' },
  { value: 'Nephrology', label: 'Nephrology' },
  { value: 'Rheumatology', label: 'Rheumatology' },
];

const ClusterListing = () => {
  const [requestList, setRequestList] = useState([]);

  const [isModalStepper, setIsModalStepper] = React.useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [Pagination, setPaginaton] = useState('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [prevPageUrl, setPrevPageUrl] = useState(null);
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [loading, setloading] = useState(false);

  const [filters, setFilters] = useState({
    request_number: '',
    medicalSpecialties: [],
    actionStatus: '',
    date: '',
  });

  const handleDebouncedChange = debounce(
    (updatedFilters, page, rowsPerPage) => {
      setloading(true);
      const payload = {
        request_number: String(
          updatedFilters.request_number || ''
        ).toLowerCase(),
        created_at: String(updatedFilters.date || '').toLowerCase(),
        medicalSpecialties: String(
          updatedFilters.medicalSpecialties
            ?.map(({ label, value }) => ({ value }))
            .join(', ') || ''
        ),
        status: String(updatedFilters.actionStatus || '').toLowerCase(),
      };

      // Use apiService to send the API request
      apiService
        .get(`job-requests?is_pagination=true&per_page=${rowsPerPage}`, payload)
        .then((response) => {
          console.log('API Response:', response?.original?.data?.data);
          setRequestList(response.data?.data);

          setTotalRows(response.data?.total);

          setloading(false);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
    500
  );

  const handleInputChange = (e) => {
    let value;
    let name;

    if (e !== null && e.target) {
      // Standard input or select element
      const { name: inputName, value: inputValue } = e.target;
      name = inputName;
      value = inputValue;
    } else {
      // Custom component like react-select
      name = 'actionStatus'; // Assuming custom component passes 'name'
      value = e; // Assuming value is passed in a custom event object
      if (Array.isArray(value)) {
        name = 'medicalSpecialties'; // Assign to medicalSpecialties
        value = value.map((item) => item);
      } else {
        console.log("It's not an array.", value);
      }
    }

    // Handle special case for 'medicalSpecialties' (if it's a comma-separated list)
    const updatedFilters = {
      ...filters,
      [name]:
        name === 'medicalSpecialties'
          ? value?.map(({ label, value }) => ({ label, value })) || []
          : value,
    };
    setFilters(updatedFilters);
    // Trigger the debounced API call
    handleDebouncedChange(updatedFilters, page, rowsPerPage);
  };

  const detailForm = (data) => {
    setSelectedRequest(data); // Set the data to be passed to the modal
    setIsModalStepper(true); // Open the modal
  };

  const renderRowActions = ({ row, table }) => {
    // const isOpen = openRowId === row.index;
    const isBlocked = row?.original?.physician?.actionStatus === 'blocked';

    return (
      <>
        <div className="flex gap-3">
          {/* <Dots
                        className="action-icon"

                    /> */}
          <RightArrow
            className="action-icon"
            onClick={() => detailForm(row?.original)}
          />
        </div>
      </>
    );
  };

  const medSp = useMedicalSpecialties();

  const handleRenderRowActions = ({ row, table }) =>
    renderRowActions({ row, table });

  const columns = [
    {
      id: 'Req #',
      header: 'Req #',
      accessorKey: 'reqNumber', // Accessing 'reqNumber' field in the data
      accessorFn: (row) => {
        return (
          <span className="font-sans font-[400] text-[18px] text-[#0A0D14]">
            {row?.requestNumber || '-'}
          </span>
        );
      },
    },
    {
      id: 'Practitioners Specialty',
      header: 'Practitioners Specialty',
      accessorKey: 'specialties', // Accessing 'specialties' field in the data
      accessorFn: (row) => {
        const specialties = row?.job_positions || [];
        const maxVisible = 2; // Number of specialties to display initially

        function getColorClass(index) {
          switch (index) {
            case 0:
              return 'bg-[#EEEBFF] text-[#2B1664]'; // First item's color
            case 1:
              return 'bg-[#FFF3E8] text-[#8D4D00]'; // Second item's color
            default:
              return 'bg-[#F0F0F0] text-[#333333]'; // Default color for the rest
          }
        }

        return (
          <div>
            {specialties.slice(0, maxVisible).map((position, index) => (
              <span
                key={index}
                className={`whitespace-normal break-words inline-block m-1 px-1.5 py-0.5 text-sm rounded ${getColorClass(
                  index
                )}`}
              >
                {position?.medical_speciality?.name}
              </span>
            ))}
            {specialties.length > maxVisible && (
              <span className="bg-[#F5F5F5] text-[#666666] whitespace-normal break-words inline-block m-1 px-1.5 py-0.5 text-sm rounded">
                +{specialties.length - maxVisible}
              </span>
            )}
          </div>
        );
      },
    },
    {
      id: 'Total No',
      header: 'Total No',
      accessorKey: 'totalNo', // Accessing 'totalNo' field in the data
      accessorFn: (row) => {
        return (
          <span className="font-sans font-[400] text-[18px] text-[#0A0D14]">
            {row?.job_positions?.length || '-'}
          </span>
        );
      },
    },
    {
      id: 'Date of Request',
      header: 'Date of Request',
      accessorKey: 'dateOfRequest', // Accessing 'dateOfRequest' field in the data
      accessorFn: (row) => {
        function formatDate(dateString) {
          const date = new Date(dateString); // Parse the input date string
          const options = { day: '2-digit', month: 'short', year: 'numeric' };
          return new Intl.DateTimeFormat('en-US', options).format(date);
        }
        const formattedDate = formatDate(row?.created_at);
        return (
          <span className="font-sans font-[400] text-[18px] text-[#0A0D14]">
            {formattedDate || '-'}
          </span>
        );
      },
    },
    {
      id: 'Status',
      header: 'Status',
      accessorKey: 'status', // Accessing 'status' field in the data
      accessorFn: (row) => {
        return (
          <span className="flex max-w-fit h-[40px] items-center gap-2 px-3 py-1 border rounded-[10px] border-gray-300">
            {row?.status ? (
              row.status === 'under_review' ? (
                <span className="font-inter font-medium text-[15px] text-[#525866] flex items-center gap-1">
                  <img src={time} alt="logo" /> Pending
                </span>
              ) : row.status === 'accepted' ? (
                <span className="font-inter font-medium text-[15px] text-[#525866] flex items-center gap-1">
                  <img src={Accepted} alt="logo" /> Accepted
                </span>
              ) : row.status === 'approved' ? (
                <span className="font-inter font-medium text-[15px] text-[#525866] flex items-center gap-1">
                  <img src={Approved} alt="logo" /> Approved
                </span>
              ) : row.status === 'partially_approved' ? (
                <span className="font-inter font-medium text-[15px] text-[#525866] flex items-center gap-1">
                  <img
                    src={Partially}
                    style={{ width: '12px', height: '12px' }}
                    alt="logo"
                  />{' '}
                  Partially Approved
                </span>
              ) : row.status === 'closed' ? (
                <span className="font-inter font-medium text-[15px] text-[#525866] flex items-center gap-1">
                  <img src={Closed} alt="logo" /> Closed
                </span>
              ) : row.status === 'rejected' ? (
                <span className="font-inter font-medium text-[15px] text-[#525866] flex items-center gap-1">
                  <img src={Rejected} alt="logo" /> Rejected
                </span>
              ) : (
                '-'
              )
            ) : (
              '-'
            )}
          </span>
        );
      },
    },
  ];

  const fetchRequests = async (filters, page, rowsPerPage) => {
    try {
      const payload = {
        request_number: String(filters?.request_number || '')?.toLowerCase(),
        created_at: String(filters?.date || '')?.toLowerCase(),
        medicalSpecialties: String(
          filters.medicalSpecialties
            ?.map(({ label, value }) => ({ value }))
            .join(', ') || ''
        ),
        status: String(filters?.actionStatus || '')?.toLowerCase(),
      };

      await new Promise((resolve) => setTimeout(resolve, 2000));
      const response = await apiService.get(
        `job-requests?is_pagination=true&per_page=${rowsPerPage}&page=${page}`,
        payload
      );
      if (response?.code === 200) {
        setRequestList(response.data?.data || []);
        setTotalRows(response?.data?.total);

        setloading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const init = (filters, page, rowsPerPage) => {
    fetchRequests(filters, page, rowsPerPage);
  };

  useEffect(() => {
    init(filters, page, rowsPerPage);
  }, [page, rowsPerPage]);

  return (
    <div>
      {isModalStepper && (
        <RequestDetail
          isCluster
          requestDetails={selectedRequest}
          init={fetchRequests}
          onClose={setIsModalStepper}
          fetchRequests={fetchRequests}
          page={page}
          rowsPerPag={rowsPerPage}
        />
      )}

      <div className="d-flex justify-content-between align-items-center p-4 bg-gray-100">
        <div className="grid grid-cols-4 gap-4">
          {/* English Name */}
          <input
            type="text"
            name="request_number"
            placeholder="Enter Request Number"
            value={filters.request_number}
            onChange={(e) => {
              handleInputChange(e, page, rowsPerPage); // Update state if input is valid
            }}
            className="px-3 py-[4px] border border-gray-300 rounded-[12px] focus:outline-none focus:ring-0 focus:bg-transparent"
          />

          {/* Action Status */}

          <CustomDropDown
            name="medicalSpecialties"
            value={
              filters.medicalSpecialties?.map((site) => ({
                label: site?.label,
                value: site?.value,
              })) || []
            }
            onFieldSelect={(e) => {
              handleInputChange(e, page, rowsPerPage);
            }}
            options={medSp?.map(({ name, _id, ...rest }) => ({
              label: name,
              value: _id,
              ...rest,
            }))}
            zIndex={'99999'}
            isMulti={true}
          />

          <CustomDropDown
            name="actionStatus"
            value={filters.actionStatus}
            onChange={handleInputChange}
            options={actionStatuses}
            zIndex={'99999'}
          />

          <input
            type="date"
            name="date"
            placeholder="Date"
            value={filters.date}
            onChange={(e) => {
              handleInputChange(e, page, rowsPerPage); // Update state if input is valid
            }}
            className="px-3 py-[4px] border border-gray-300 rounded-[12px] focus:outline-none focus:ring"
          />
        </div>

        <div className="flex justify-center items-center gap-2">
          <div className="mt-2 pl-2">Total Count:{totalRows}</div>
          <div className="mt-2 pl-2"></div>
        </div>
      </div>

      <DataTableReact
        data={requestList}
        columns={columns}
        renderRowActions={handleRenderRowActions}
        Pagination={Pagination}
        prevPageUrl={prevPageUrl}
        nextPageUrl={nextPageUrl}
        totalRows={totalRows}
        setPage={setPage}
        page={page}
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        loading={loading}
        shouldShowActions={true}
      />
    </div>
  );
};

export default ClusterListing;

// {isModalOpen && (
//     <NewRequest onClose={handleClose} />
// )}

// {isModalStepper && (<RequestDetail onClose={setIsModalStepper} />
// )}

// <img src={addline} alt="logo" />
